/* Fire ikoner: to for atferd, to for appetitt.
 *
 * De markerer ENDENE av skalaen, ikke hvert trinn. Skåren er 0–3 og blir stående
 * som tall — det er tallet protokollen definerer og det er tallet en revisor
 * leser — men et tall alene sier ikke hvilken vei skalaen går. Et ikon i hver
 * ende gjør det, og gjør det på avstand.
 *
 * SAMME DISIPLIN SOM Fish.tsx, som er nabofila og har argumentet: samme kropp,
 * samme hale, og én ting som endrer seg. Der er det munnen. Her er det
 * stillingen for atferd og pelleten for appetitt. Alt utover det — en trist
 * fisk, et utropstegn — slutter å være en avlesning og blir en mening med
 * ansikt på.
 *
 * HVORFOR IKKE ETT IKON PER NIVÅ
 *   Fordi nivåene ikke er fire tilstander, de er en gradering av andel: «mindre
 *   grupper avvikende individer» mot «store deler av gruppen» (§4.1). Fire
 *   tegninger av det ville vært fire tegninger av det samme, og leseren måtte
 *   sammenlikne dem for å finne ut hvilken de så på. To ender og et tall er
 *   raskere å lese og påstår mindre.
 *
 * Tegnet i `currentColor` alene, så knappen setter fargen og ikonet arver den.
 */

export type Ikon = 'atferd-normal' | 'atferd-avvik'
  | 'appetitt-spiser' | 'appetitt-nei'

/** Kroppen. Samme fisk i alle fire, bare rotert der det betyr noe. */
const FISK = 'M9 11 C9 7.4 13 5.4 17.6 5.4 C21.3 5.4 24 7.8 24 11'
  + ' C24 14.2 21.3 16.6 17.6 16.6 C13 16.6 9 14.6 9 11 Z'
const HALE = 'M9 11 L4 7.4 L4 14.6 Z'
const ØYE = { cx: 20.2, cy: 9.4, r: 1.05 }

export function Velferdsikon({ ikon }: { ikon: Ikon }) {
  /* ÉN fisk, ikke to. Første forsøk tegnet en stim og lot antallet avvikende
     variere; rotert om feil punkt falt halen av kroppen, og to fisk i en
     30x22-boks ble to flekker. Fish.tsx har svaret allerede: samme kropp, én
     ting som endrer seg. Her er det stillingen, eller hvor pelleten er. */
  const skrå = ikon === 'atferd-avvik'
  const plassering = skrå
    ? 'translate(1,2) scale(0.8) rotate(-24 14 11)'
    : 'translate(1,2) scale(0.8)'

  return (
    <svg viewBox="0 0 30 22" width="30" height="22" fill="none"
         stroke="currentColor" strokeWidth="1.7"
         strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true">
      <g transform={plassering}>
        <path d={HALE} />
        <path d={FISK} />
        <circle {...ØYE} fill="currentColor" stroke="none" />
      </g>

      {/* Atferd: forskjellen ER stillingen, og den er tegnet over.
          Protokollen har sitt eget ord for fisken som står på skrå oppe i
          vannet — en «svimer» — og at den havner der er nettopp grunnen til at
          den er synlig fra merdkanten. Ingen strek er lagt til for å
          understreke det. */}

      {ikon === 'appetitt-spiser' && (
        /* Pelleten rett foran munnen, ikke oppe i hjørnet: det er nærheten som
           gjør at det leses som spising og ikke som en fisk og en prikk. */
        <circle cx="24.4" cy="9.4" r="1.8" fill="currentColor" stroke="none" />
      )}

      {ikon === 'appetitt-nei' && (
        /* Den samme pelleten, falt forbi. Fisken står vannrett og gjør
           ingenting — ingen grimase, bare fôr som ikke ble tatt. */
        <circle cx="24.4" cy="18.2" r="1.8" fill="currentColor" stroke="none" />
      )}
    </svg>
  )
}
